import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PosFloatingActionButtonService {
  addItems() {
    this.action.next("addItems");
  }
  removeItems() {
    this.action.next("removeItems");
  }

  public action: BehaviorSubject<string> = new BehaviorSubject<string>("removeItems");
  public observableAction = this.action.asObservable();
  actions: {
    id: string, fn: (() => any),
    icon: string,
    tooltip: string
  }[] = new Array()
  public show: boolean = false;
  constructor() {


  }

  setActions(actions: {
    id: string, fn: (() => any),
    icon: string,
    tooltip: string
  }[] = new Array()) {
    this.actions = actions;
  }

  getActions() {
    return this.actions;
  }

  setShow(show: boolean) {
    this.show = show;
  }

  getShow() {
    return this.show;
  }
}
